class DegreeModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'DegreeModal';

    $scope.degree = {};

    $scope.cancel = function () {
      $scope.degree = {};
      $uibModalInstance.cancel();
    };

    $scope.addDegree = function() {
      $http.post($rootScope.apiHost+"/api/admin/companies/1/degrees", $scope.degree, {withCredentials: true}).then(function (success) {
        $uibModalInstance.success();
      }, function (failure) {
        $scope.errorMessage = failure.data.message;
      });
    }

    $scope.cancel = function() {
      $uibModalInstance.cancel();
    }

    $scope.missingRequiredValues = function() {
      let allValuesPresent = $scope.degree.type && $scope.degree.discipline;
      return !allValuesPresent;
    }

  }





}

export default DegreeModalController;



// WEBPACK FOOTER //
// ./client/common/modals/degreeModal/degreeModal.controller.js